import React from 'react';
export var ChevronDownIcon = function ChevronDownIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "28",
    height: "17",
    viewBox: "0 0 28 17"
  }, React.createElement("path", {
    d: "M0 2.83008L2.83 6.10352e-05L14 11.1701L25.18 6.10352e-05L28 2.83008L14 16.8301L0 2.83008Z"
  }));
};